import React, { Fragment } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import classNames from "classnames";
import { numberWithCommas } from "../../lib/Common";
const BaseTableCell = withStyles((theme) => ({
  body: {
    fontSize: "0.8rem",
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 8,
    paddingBottom: 8,
    border: "0.5px solid",
  },
}))(TableCell);
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  firstCell: {
    backgroundColor: "pink",
    color: "black",
    fontWeight: "bold",
  },
  table: {
    marginTop: "6%",
    tableLayout: "fixed",
  },
  bottomBold: {
    borderBottom: "solid",
  },
  rightBold: {
    borderRight: "solid",
  },
  hiddenBold: {
    paddingTop: 7,
    paddingBottom: 7,
    border: "none",
  },
});

export default function ResultTable({ styleInfo, partStock, partStockInfo }) {
  const classes = useStyles();
  let rowColorName = "no";
  let rowColorNameInfo = "no";
  let mergeflag = false;
  let colorCount = 0;
  let colorLoop = 1;
  return (
    <Fragment>
      {partStock === null ||
      styleInfo === null ||
      partStockInfo === null ? null : (
        <Table className={classes.table}>
          <TableBody>
            <TableRow>
              <BaseTableCell className={classes.bottomBold} align="center">
                품번
              </BaseTableCell>
              <BaseTableCell
                colSpan="6"
                align="center"
                className={classNames(classes.bottomBold, classes.rightBold)}
              >
                {styleInfo.styleno}
              </BaseTableCell>
            </TableRow>
            <TableRow>
              <BaseTableCell colSpan="6" className={classes.hiddenBold}>
                {" "}
              </BaseTableCell>
            </TableRow>
            <TableRow>
              <BaseTableCell align="center">TAG가</BaseTableCell>
              <BaseTableCell colSpan="2" align="right">
                {numberWithCommas(styleInfo.tagprice)}
              </BaseTableCell>
              <BaseTableCell rowSpan="2" align="center">
                판매가
              </BaseTableCell>
              <BaseTableCell
                rowSpan="2"
                colSpan="3"
                align="right"
                className={classes.rightBold}
              >
                {numberWithCommas(styleInfo.amt)}
              </BaseTableCell>
            </TableRow>
            <TableRow>
              <BaseTableCell className={classes.bottomBold} align="center">
                할인율
              </BaseTableCell>
              <BaseTableCell
                colSpan="2"
                align="right"
                className={classes.bottomBold}
              >
                {styleInfo.saledc}%
              </BaseTableCell>
            </TableRow>
            <TableRow>
              <BaseTableCell colSpan="6" className={classes.hiddenBold}>
                {" "}
              </BaseTableCell>
            </TableRow>
            <TableRow>
              <BaseTableCell align="center">색상</BaseTableCell>
              <BaseTableCell align="center">사이즈</BaseTableCell>
              <BaseTableCell align="right">매장</BaseTableCell>
              <BaseTableCell align="right">온라인</BaseTableCell>
              <BaseTableCell align="right">이월</BaseTableCell>
              <BaseTableCell align="right">임시</BaseTableCell>
              <BaseTableCell align="right" className={classes.rightBold}>
                신상
              </BaseTableCell>
            </TableRow>

            {partStock.map((row) => {
              console.log(row);

              if (rowColorName === "no") {
                colorCount = Number(styleInfo.colorcount);
                rowColorName = row.colorcode;
                mergeflag = true;
              } else if (rowColorName !== row.colorcode) {
                colorLoop++;
                rowColorName = row.colorcode;
                mergeflag = true;
              } else {
                mergeflag = false;
              }
              return (
                <StyledTableRow
                  key={row.id}
                  className={
                    row.id === partStock.length ? classes.bottomBold : null
                  }
                >
                  {mergeflag ? (
                    <BaseTableCell
                      className={classNames(
                        classes.firstCell,
                        colorLoop === colorCount ? classes.bottomBold : null
                      )}
                      scope="row"
                      rowSpan={partStock.length / styleInfo.colorcount}
                      align="center"
                    >
                      {row.colorcode}
                    </BaseTableCell>
                  ) : null}
                  <BaseTableCell align="center">{row.sizecode}</BaseTableCell>
                  <BaseTableCell align="right">{row.partcode}</BaseTableCell>
                  <BaseTableCell align="right">{row.A1801}</BaseTableCell>
                  <BaseTableCell align="right">{row.A1771}</BaseTableCell>
                  <BaseTableCell align="right">{row.A1818}</BaseTableCell>
                  <BaseTableCell align="right" className={classes.rightBold}>
                    {row.A1770}
                  </BaseTableCell>
                </StyledTableRow>
              );
            })}
            <TableRow>
              <BaseTableCell colSpan="7" className={classes.hiddenBold}>
                {" "}
              </BaseTableCell>
            </TableRow>
            <TableRow>
              <BaseTableCell align="center">색상</BaseTableCell>
              <BaseTableCell align="center">사이즈</BaseTableCell>
              <BaseTableCell align="right">입고</BaseTableCell>
              <BaseTableCell align="right">반품</BaseTableCell>
              <BaseTableCell align="right">판매</BaseTableCell>
              <BaseTableCell align="right" className={classes.rightBold} colSpan="2">
              재고
              </BaseTableCell>
            </TableRow>

            {partStockInfo !== null &&
              partStockInfo.map((row) => {
                if (rowColorNameInfo === "no") {
                  colorLoop = 1;
                  colorCount = Number(styleInfo.colorcount);
                  rowColorNameInfo = row.colorcode;
                  mergeflag = true;
                } else if (rowColorNameInfo !== row.colorcode) {
                  colorLoop++;
                  rowColorNameInfo = row.colorcode;
                  mergeflag = true;
                } else {
                  mergeflag = false;
                }
                return (
                  <StyledTableRow
                    key={row.id}
                    className={
                      Number(row.id) === partStockInfo.length
                        ? classes.bottomBold
                        : null
                    }
                  >
                    {mergeflag ? (
                      <BaseTableCell
                        className={classNames(
                          classes.firstCell,
                          colorLoop === colorCount ? classes.bottomBold : null
                        )}
                        scope="row"
                        rowSpan={partStockInfo.length / styleInfo.colorcount}
                        align="center"
                      >
                        {row.colorcode}
                      </BaseTableCell>
                    ) : null}
                    <BaseTableCell align="center">{row.sizecode}</BaseTableCell>
                    <BaseTableCell align="right">{row.inqty}</BaseTableCell>
                    <BaseTableCell align="right">{row.returnqty}</BaseTableCell>
                    <BaseTableCell align="right">{row.saleqty}</BaseTableCell>
                    <BaseTableCell align="right" className={classes.rightBold} colSpan="2">
                    {row.stockqty}                    
                    </BaseTableCell>
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </Table>
      )}
    </Fragment>
  );
}
